import { createBagsAnalytic } from './bagsAnalyticSchemes';
import { createFacecoverAnalytic } from './facecoverAnalyticSchemes';
import { createFallAnalytic } from './fallAnalyticSchemes';
import { createFightAnalytic } from './fightAnalyticSchemes';
import { createFireAnalytic } from './fireAnalyticSchemes';
import { createHandsupAnalytic } from './handsupAnalyticSchemes';
import { createLyingAnalytic } from './lyingAnalyticSchemes';
import { createPeopleCountAnalytic } from './peopleCountAnalyticSchemes';
import { createWeaponAnalytic } from './weaponAnalyticSchemes';
import { STREAM_DATA_TYPE_OPTIONS } from '../../../constants';
import { get, CleanSchema } from '../../../json-transform';

const optionLabel = (obj) => obj?.label;

export const create = new CleanSchema({
  name: get('name').ifEmptyString(undefined),
  description: get('description').ifEmptyString(undefined),
  group_name: get('group_name').as(optionLabel),
  splittable: get('splittable').asInt(),
  data: {
    // FIXME: это костыль для таски GUI-2716
    downloadable: get('data.type').switch((type) => type.value, {
      [STREAM_DATA_TYPE_OPTIONS.stream.value]: () => false,
      [STREAM_DATA_TYPE_OPTIONS.videofile.value]: () => true,
    }),
    // FIXME: это надо вернуть когда поле downloadable появится в ui
    // downloadable: get('data.downloadable').asBoolean(),
    type: get('data.type').asOptionValue(),
    reference: get('data.reference'),
    rotation: get('data.rotation').asOptionValue(),
    timestamp_source: get('data.timestamp_source').asOptionValue(),
    pts: {
      start_time: get('data.pts.start_time').asFloat().ifNaN(undefined),
    },
  },
  location: {
    city: get('location.city').ifEmpty(null),
    area: get('location.area').ifEmpty(null),
    district: get('location.district').ifEmpty(null),
    street: get('location.street').ifEmpty(null),
    house_number: get('location.house_number').ifEmpty(null),
    geo_position: {
      longitude: get('location.geo_position.longitude').asFloat().ifNaN(undefined),
      latitude: get('location.geo_position.latitude').asFloat().ifNaN(undefined),
    },
  },
  autorestart: {
    restart: get('autorestart.restart').asBoolean(),
    attempt_count: get('autorestart.attempt_count').asInt().ifNaN(undefined),
    delay: get('autorestart.delay').asInt().ifNaN(undefined),
  },
  analytics: get('analytics').asArrayOf((analytic) => {
    switch (analytic.analytic_name) {
      case 'people_count': return createPeopleCountAnalytic(analytic);
      case 'weapon_analytics': return createWeaponAnalytic(analytic);
      case 'fights_analytics': return createFightAnalytic(analytic);
      case 'fire_analytics': return createFireAnalytic(analytic);
      case 'facecover_analytics': return createFacecoverAnalytic(analytic);
      case 'lying_analytics': return createLyingAnalytic(analytic);
      case 'bags_analytics': return createBagsAnalytic(analytic);
      case 'handsup_analytics': return createHandsupAnalytic(analytic);
      case 'fall_analytics': return createFallAnalytic(analytic);
      default: return analytic;
    }
  }),
});
